import { useCallback, useState, useRef } from 'react';
import type { ReactNode } from 'react';
import Media from 'react-media';
import loadable from '@loadable/component';

import { Button, Modal, useTheme } from '@simplywallst/ui-core';
import PlusSolid from '@simplywallst/ui-core/icons/PlusSolid';

import { useWatchlist } from '@/hooks/useWatchlist';
import useWatchlistMutations from '../../hooks/useWatchlistMutations';

import { ResultWrapper, Search as Wrapper } from './styled';

const AlgoliaSearch = loadable(
  () => import('@/components/Search/components/AlgoliaSearch')
);
const BasicSearch = loadable(
  () => import('@/components/Search/components/BasicSearch')
);

const Search = () => {
  const theme = useTheme();
  const ticker = useRef('');
  const [query, setQuery] = useState('');
  const { data: watchlist } = useWatchlist();
  const { addCompany } = useWatchlistMutations();
  const [showSearch, setShowSearch] = useState(false);

  const handleClick = useCallback(
    () => setShowSearch((prevState) => !prevState),
    []
  );

  const handleSelect = useCallback(
    (id: string) => {
      if (typeof watchlist === 'undefined') {
        return;
      }
      addCompany({
        id,
        includeSnackBar: true,
        watchlistId: watchlist.id,
      });
      setQuery('');
      ticker.current = id.substring(id.indexOf(':') + 1);
      setShowSearch(false);
    },
    [addCompany, watchlist]
  );

  const getResult = useCallback(
    (
      child: ReactNode,
      result: {
        uniqueSymbol: string;
      }
    ) => (
      <ResultWrapper
        onClick={() => {
          handleSelect(result.uniqueSymbol);
        }}
      >
        {child}
      </ResultWrapper>
    ),
    [handleSelect]
  );

  return (
    <Wrapper>
      {showSearch ? (
        <Media query={{ maxWidth: theme.mdMaxRaw }}>
          {(match) => {
            if (match) {
              return (
                <Modal isNaked onSecondaryClick={handleClick}>
                  <AlgoliaSearch
                    onClose={handleClick}
                    onSearchResult={(_results, query) => {
                      setQuery(query);
                    }}
                    onReset={() => setQuery('')}
                    query={query}
                    primaryWrapper={getResult}
                    secondaryWrapper={getResult}
                  />
                </Modal>
              );
            }
            return (
              <BasicSearch
                name="search-add-company"
                placeholder="Add Company"
                onClick={handleSelect}
              />
            );
          }}
        </Media>
      ) : (
        <Button
          styleType="louderLarge"
          alignIcon="left"
          onClick={handleClick}
          data-cy-id="add-stock"
        >
          <PlusSolid />
          Add Stock
        </Button>
      )}
    </Wrapper>
  );
};

export default Search;
